import React from 'react';
import { useNavigate } from 'react-router-dom';

interface FormLayoutProps {
  title: string;
  subtitle?: string;
  isLoading?: boolean;
  children: React.ReactNode;
  onCancel?: () => void;
  onSave?: () => void;
  saveButtonText?: string;
  cancelButtonText?: string;
  showActions?: boolean;
  entityId?: string | number;
}

const FormLayout: React.FC<FormLayoutProps> = ({
  title,
  subtitle,
  isLoading = false,
  children,
  onCancel,
  onSave,
  saveButtonText = 'Salvar',
  cancelButtonText = 'Cancelar',
  showActions = true,
  entityId
}) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <button className="btn btn-secondary" onClick={handleCancel} disabled={isLoading}>
          <i className="fas fa-arrow-left"></i>
          {cancelButtonText}
        </button>
        <div>
          <h1>{title}</h1>
          {subtitle && <p className="text-muted">{subtitle}</p>}
          {entityId && <span className="text-muted">ID: {entityId}</span>}
        </div>
      </div>

      <div className="page-content">
        <div className="card">
          <div className="card-header">
            <h2>{title}</h2>
            {entityId && <span className="text-muted">ID: {entityId}</span>}
          </div>
          
          <div className="card-body">
            {children}
          </div>

          {showActions && (
            <div className="card-footer">
              <div className="form-actions">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                  disabled={isLoading}
                >
                  {cancelButtonText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSave}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="loading"></span>
                      Salvando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save"></i>
                      {saveButtonText}
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormLayout;
